module.exports = __webpack_public_path__ + "img/inquiry_even.9b55ffa5.svg";